import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpace: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSpace"><Path d="M5.07175 18.5C6.80484 16.6535 9.26772 15.5 12 15.5C14.7323 15.5 17.1952 16.6535 18.9282 18.5M5.07175 18.5C6.80484 20.3465 9.26772 21.5 12 21.5C14.7323 21.5 17.1952 20.3465 18.9282 18.5M5.07175 18.5C3.47685 16.8007 2.5 14.5144 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 14.5144 20.5231 16.8007 18.9282 18.5M11 8L9 9L11 10L12 12L13 10L15 9L13 8L12 6L11 8Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSpace;
